import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';

import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

HighchartsBorderRadius(Highcharts);

@Component({
	selector: 'app-chart',
	styleUrls: ['./chart.component.css'],
	templateUrl: './chart.component.html'
})
export class ChartComponent implements OnInit, OnChanges, OnDestroy {
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;
	@Input() chartData: any;
	@Input() setcolor: any;
	public chartObj: any;
	public plotOptions: any;
	constructor(protected colorUtilityService: ColorUtilityService, protected analyticsDataModel: AnalyticsDataModel) {
		EmitterService.get(EVENT_EMITTERS.CAROUSEL_CHART_REDRAW).subscribe((res) => {
			if (typeof this.chartObj !== 'undefined' && this.chartObj.chart) {
				this.chartObj.reflow();
			}
		});
	}

	ngOnInit(): void {}

	ngOnChanges(): void {
		if (this.chartData) {
			this.chartData.average_baseline =
				UtilityService.isUndefinedOrNull(Number(this.chartData.average_baseline)) ||
				Number(this.chartData.average_baseline) === 0
					? '<0.01'
					: this.chartData.average_baseline;
		}
		this.renderChart(this.chartData);
	}

	ngOnDestroy(): void {
		if (this.chartObj) {
			this.chartObj.destroy();
		}
	}

	renderChart(chartData: any): void {
		this.plotOptions = {
			area: {
				marker: {
					enabled: false
				}
			},
			column: {
				borderWidth: 0,
				pointWidth: 15
			},
			series: {
				states: {
					inactive: {
						opacity: 1
					}
				}
			}
		};
		const yAxisLabelSecondary = {
			formatter(): string {
				return this.value + '%';
			}
		};
		const yAxisPrimaryLabel = {
			formatter(): string {
				return this.value + 'x Lift';
			},
			style: {
				color: this.colorUtilityService.getHEXByColorType(this.analyticsDataModel.partner.colorPalette, 'tertiary', 1)
			}
		};
		if (typeof chartData !== 'undefined') {
			this.chartObj = new Highcharts.Chart({
				chart: {
					alignTicks: chartData.alignTicks !== undefined ? chartData.alignTicks : true,
					backgroundColor: this.setcolor ? this.setcolor : '',
					height: chartData.height ? chartData.height : 300,
					margin: chartData && chartData.margin ? chartData.margin : [40, 60, 60, 50],
					renderTo: this.chartElement.nativeElement,
					spacing: chartData && chartData.spacing ? chartData.spacing : [10, 10, 15, 10],
					type: chartData && chartData.type ? chartData.type : '',
					width: chartData.width ? chartData.width : null
				},
				credits: {
					enabled: false
				},
				legend: chartData.legendLayout ? chartData.legendLayout : {},
				plotOptions: chartData.plotOptions ? chartData.plotOptions : this.plotOptions,
				series: chartData.graphData,
				subtitle: chartData.subtitle ? chartData.subtitle : '',
				title: chartData.title ? chartData.title : '',
				tooltip: chartData.tooltip ? chartData.tooltip : {},
				xAxis: [
					{
						categories: chartData.xAxis && chartData.xAxis.categories ? chartData.xAxis.categories : [],
						labels: chartData.xAxis && chartData.xAxis.labels ? chartData.xAxis.labels : [],
						lineColor: chartData.xAxis && chartData.xAxis.lineColor ? chartData.xAxis.lineColor : 'transparent',
						lineWidth: chartData.xAxis && chartData.xAxis.lineWidth ? chartData.xAxis.lineWidth : 0,
						minorGridLineWidth: 0,
						minorTickLength: 0,
						tickLength: chartData.xAxis && chartData.xAxis.tickLength ? chartData.xAxis.tickLength : 0,
						tickWidth: chartData.xAxis && chartData.xAxis.tickWidth ? chartData.xAxis.tickWidth : 0,
						title: {
							text: null
						}
					}
				],
				yAxis: [
					{
						// Secondary yAxis
						ceiling:
							chartData && chartData.yAxisSecondary && chartData.yAxisSecondary.ceiling
								? chartData.yAxisSecondary.ceiling
								: null,
						gridLineColor: chartData.gridLineColor || 'transparent',
						labels:
							chartData && chartData.yAxisSecondary && chartData.yAxisSecondary.labels
								? chartData.yAxisSecondary.labels
								: yAxisLabelSecondary,
						lineColor:
							chartData.yAxisSecondary && chartData.yAxisSecondary.lineColor
								? chartData.yAxisSecondary.lineColor
								: 'transparent',
						lineWidth:
							chartData.yAxisSecondary && chartData.yAxisSecondary.lineWidth ? chartData.yAxisSecondary.lineWidth : 0,
						min: 0,
						minorGridLineWidth: 0,
						title:
							chartData && chartData.yAxisSecondaryTitle
								? chartData.yAxisSecondaryTitle
								: {
										text: null
								  }
					},
					{
						// Primary yAxis
						ceiling:
							chartData && chartData.yAxisPrimary && chartData.yAxisPrimary.ceiling
								? chartData.yAxisPrimary.ceiling
								: null,
						gridLineColor: 'transparent',
						labels:
							chartData && chartData.yAxisPrimary && chartData.yAxisPrimary.labels
								? chartData.yAxisPrimary.labels
								: yAxisLabelSecondary,
						lineColor:
							chartData.yAxisPrimary && chartData.yAxisPrimary.lineColor
								? chartData.yAxisPrimary.lineColor
								: 'transparent',
						lineWidth:
							chartData.yAxisPrimary && chartData.yAxisPrimary.lineWidth ? chartData.yAxisPrimary.lineWidth : 0,
						min: 0,
						minorGridLineWidth: 0,
						opposite: true,
						title:
							chartData && chartData.yAxisPrimaryTitle
								? chartData.yAxisPrimaryTitle
								: {
										text: null
								  }
					}
				]
			});
		}
	}
}
